import {
    terminalType,
    normalPinNum,
    relayPinNum,
    TerminalType,
    TerminalSide,
    DORelayTypeOptions,
    DoRelayType,
} from 'icreate/common/models/slot';

export type TerminalOption = {
    type: TerminalType;
    titleKey: string;
    terminalCount: number;
    doRelayType?: DoRelayType;
};
export const terminalOptions: TerminalOption[] = [
    {
        type: terminalType.normal,
        titleKey: 'system-settings.do-slot.normal.title',
        terminalCount: normalPinNum,
    },
    {
        type: terminalType.relay,
        doRelayType: DORelayTypeOptions.relay,
        titleKey: 'system-settings.do-slot.relay.title',
        terminalCount: relayPinNum,
    },
    {
        type: terminalType.relay,
        doRelayType: DORelayTypeOptions.relayCommonCom,
        titleKey: 'system-settings.do-slot.relay-common-com.title',
        terminalCount: relayPinNum,
    },
    {
        type: terminalType.relay,
        doRelayType: DORelayTypeOptions.relayAc220v,
        titleKey: 'system-settings.do-slot.relay-ac220v.title',
        terminalCount: relayPinNum,
    },
    {
        type: terminalType.relay,
        doRelayType: DORelayTypeOptions.relayAc220vCommonCom,
        titleKey: 'system-settings.do-slot.relay-ac220v-common-com.title',
        terminalCount: relayPinNum,
    },
];

export const terminalTitles: Record<TerminalType, string> = {
    [terminalType.normal]: 'system-settings.do-slot.normal.title',
    [terminalType.relay]: 'system-settings.do-slot.relay.title',
};

export const doRelayTitles: Record<DoRelayType, string> = {
    [DORelayTypeOptions.relay]: 'system-settings.do-slot.relay.title',
    [DORelayTypeOptions.relayCommonCom]: 'system-settings.do-slot.relay-common-com.title',
    [DORelayTypeOptions.relayAc220v]: 'system-settings.do-slot.relay-ac220v.title',
    [DORelayTypeOptions.relayAc220vCommonCom]: 'system-settings.do-slot.relay-ac220v-common-com.title',
};

export const terminalSides: Record<TerminalSide, string> = {
    [TerminalSide.LEFT]: 'system-settings.do-slot.side.left',
    [TerminalSide.RIGHT]: 'system-settings.do-slot.side.right',
    [TerminalSide.UNDEFINED]: '',
};
